const doc = [({"da":({"js":({"admin":({"roles":({"show":({"the_role_was_deleted":"Rollen blev slettet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;